export const theme = {
  textColor: {
    primaryBlack: "#000000",
    secondaryBlack: "#555555",
    primaryWhite: "#ffffff",
    primaryGray: "#e1e1e1",
    secondaryGray: "#aaaaaa",
    tertiaryGray: "#999999",
    quaternaryGray: "#666666",
    darkGray: "#444444",
    hoverGray: "#d3d3d3",
    lightGray: "#dadada",
    secondaryWhite: "#f5f5f5",
    primaryRed: "#dc3545",
    primaryYellow: "#ffc107",
    hoverRed: "#c82333",
    hoverYellow: "#ffd740",
    primarySuccess: "#28a745",
  },
  backgroundColor: {
    primaryBlack: "#000000",
    secondaryBlack: "#555555",
    primaryWhite: "#ffffff",
    secondaryWhite: "#f5f5f5",
    primaryGray: "#e1e1e1",
    secondaryGray: "#aaaaaa",
    hoverGray: "#d3d3d3",
    primaryRed: "#dc3545",
    primaryYellow: "#ffc107",
    hoverRed: "#c82333",
    hoverYellow: "#ffd740",
    primarySuccess: "#28a745",
  },
};
